// frontend/src/utils/errorHandling.ts
import toast from 'react-hot-toast';

interface ErrorResponse {
  detail?: string;
  [key: string]: any;
}

export const getErrorMessage = (error: any): string => {
  if (error.response && error.response.data) {
    const errorData: ErrorResponse = error.response.data;
    if (errorData.detail) {
      return errorData.detail;
    }
    // Handle Django REST Framework validation errors
    if (typeof errorData === 'object') {
      const messages = Object.values(errorData).flat();
      if (messages.length > 0) {
        return messages.join(', ');
      }
    }
  } else if (error.message) {
    return error.message;
  }
  return 'An unexpected error occurred.';
};

export const handleError = (error: any, context: string = 'Operation'): string => {
  const message = getErrorMessage(error);
  console.error(`${context} failed:`, message, error);
  toast.error(`${context} failed: ${message}`);
  return message;
};
